var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"iconfont star",attrs:{"id":""}},[_c('span',{staticClass:"star-val",style:(("width:" + _vm.progressVal + "%"))})])}
var staticRenderFns = []

export { render, staticRenderFns }